<script>
    /**
     * vue-infinite-loading 을 쉽게 사용하기 위한 Helper 믹스인입니다.
     */
    export default {
        name: "VueInfiniteLoadingHelper",
        props: {
        },
        data() {
            return {
                infiniteId: +new Date(), // 이 값이 변경되면 vue-infinite-loading 컴포넌트가 초기화됩니다.
                infiniteStatus: 0,
                infiniteLoading: false,
            };
        },
        computed: {
            /**
             * fetch 메서드가 존재하면 인피니트가 가능합니다.
             */
            canInfinitePagination() {
                return this.infinitePagination && !!this.fetch;
            },
        },
        methods: {
            pushItems(items) {
            },

            /**
             * vue-infinite-loading 핸들러입니다.
             *
             * @infinite 이벤트가 발생할 때 이 메서드를 호출하세요.
             */
            infiniteHandler($state) {
                if (!this.fetch) {
                    console.error("Need fetch() method to infinite scroll!");
                    return;
                }

                this.infiniteLoading = true;
                this.fetch(this.ipage, this.itemsPerPage, this.innerSortByComputed, this.innerSortDesc)
                    .then((items) => {
                        this.infiniteLoading = false;
                        if (items.length === this.itemsPerPage) {
                            this.ipage += 1;
                            this.pushItems(items);
                            $state.loaded();
                        } else if (items.length < this.itemsPerPage) {
                            this.ipage += 1;
                            this.pushItems(items);
                            $state.complete();
                            this.infiniteStatus = 2;
                        } else {
                            $state.complete();
                            this.infiniteStatus = 2;
                        }
                    })
                    .catch(e => { // 데이터 로드중 에러가 발생하면 error 처리합니다.
                        this.infiniteLoading = false;
                        $state.error();
                        this.infiniteStatus = 3;
                    });
            },

            /**
             * vue-infinite-loading 을 초기화합니다.
             */
            changeType() {
                console.log("jjw changeType")
                this.ipage = 1;
                this.list = [];
                this.infiniteId += 1;
                this.infiniteStatus = 0;
            },
        },
    }
</script>
